<template>
  <div class="draw-div">
    <h1 class="anchor-top-left">
      <img @click="sendCanvas" class="icon-margin button icon" src="./img/plane.svg" alt="">
      <img @click="$emit('show', 'mainscreen')" class="icon-margin button icon" src="./img/close.svg" alt="">
    </h1>
    <!-- <button @click="sendCanvas">Send</button>
    <button @click="$emit('show', 'mainscreen')">Close</button> -->
    <canvas class="cancan" ref="cancan"></canvas>
  </div>
</template>

<script>
import * as LoadImg from 'blueimp-load-image'
import NProgress from 'nprogress'
const SimpleDrawingBoard = require('simple-drawing-board')
// https://yoteachapp.com/yo/yoteach

/* eslint-disable */
function drawImageProp(ctx, img, x, y, w, h, offsetX, offsetY) {
  if (arguments.length === 2) {
      x = y = 0;
      w = ctx.canvas.width;
      h = ctx.canvas.height;
  }

  // default offset is center
  offsetX = typeof offsetX === "number" ? offsetX : 0.5;
  offsetY = typeof offsetY === "number" ? offsetY : 0.5;

  // keep bounds [0.0, 1.0]
  if (offsetX < 0) offsetX = 0;
  if (offsetY < 0) offsetY = 0;
  if (offsetX > 1) offsetX = 1;
  if (offsetY > 1) offsetY = 1;

  var iw = img.width,
      ih = img.height,
      r = Math.min(w / iw, h / ih),
      nw = iw * r,   // new prop. width
      nh = ih * r,   // new prop. height
      cx, cy, cw, ch, ar = 1;

  // decide which gap to fill
  if (nw < w) ar = w / nw;
  if (Math.abs(ar - 1) < 1e-14 && nh < h) ar = h / nh;  // updated
  nw *= ar;
  nh *= ar;

  // calc source rectangle
  cw = iw / (nw / w);
  ch = ih / (nh / h);

  cx = (iw - cw) * offsetX;
  cy = (ih - ch) * offsetY;

  // make sure source rectangle is valid
  if (cx < 0) cx = 0;
  if (cy < 0) cy = 0;
  if (cw > iw) cw = iw;
  if (ch > ih) ch = ih;

  // fill image in dest. rectangle
  ctx.drawImage(img, cx, cy, cw, ch,  x, y, w, h);
}

function drawImageScaled(ctx, img) {
  var canvas = ctx.canvas
  var hRatio = canvas.width / img.width
  var vRatio =  canvas.height / img.height
  var ratio  = Math.min(hRatio, vRatio)
  var centerShift_x = (canvas.width - img.width*ratio) / 2
  var centerShift_y = (canvas.height - img.height*ratio) / 2
  ctx.clearRect(0,0,canvas.width, canvas.height)
  ctx.drawImage(img, 0,0, img.width, img.height, centerShift_x,centerShift_y,img.width*ratio, img.height*ratio)
}
/* eslint-enable */

export default {
  props: {
  },
  data () {
    return {
      size: 2 * (window.devicePixelRatio || 1.0),
      sdb: false,
      defaultImage: `data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7`
    }
  },
  mounted () {
    this.resizeCanvas()
  },
  methods: {
    resizeCanvas () {
      // let dpi = window.devicePixelRatio || 1.0
      this.$refs['cancan'].width = 1024
      this.$refs['cancan'].height = 1024 * 1 / (window.innerWidth / window.innerHeight)
    },
    reset ({ imageURL }) {
      let canvas = this.$refs['cancan']
      var context = canvas.getContext('2d')
      this.resizeCanvas()
      this.cleanCanvas({ context })
      this.drawBG({ context, imageURL: imageURL || this.defaultImage })
    },
    drawBG ({ context, imageURL }) {
      return new Promise((resolve, reject) => {
        NProgress.start()
        setTimeout(() => {
          NProgress.done()
        }, 1000 * 20)
        LoadImg(imageURL, (correctedCanvas) => {
          // let rect = this.$refs['cancan'].getBoundingClientRect()
          // let dpx = 1.0 // window.devicePixelRatio || 1.0
          let canvas2d = document.createElement('canvas')
          canvas2d.width = 1024
          canvas2d.height = 1024 * 1 / (window.innerWidth / window.innerHeight)
          // * (correctedCanvas.width / correctedCanvas.height)
          // // drawImageProp(canvas2d.getContext('2d'), correctedCanvas)

          drawImageScaled(canvas2d.getContext('2d'), correctedCanvas)

          this.sdb = new SimpleDrawingBoard(context.canvas, {
            lineColor: '#FF0000',
            lineSize: this.size,
            boardColor: 'white',
            historyDepth: 10
          })
          this.sdb.setImg(canvas2d, true)
          resolve()
          NProgress.done()
        }, {
          orientation: true,
          canvas: true, // ,
          crossOrigin: window.location.origin || '*'
        })
      })
    },
    cleanCanvas ({ context }) {
      context.fillStyle = 'white'
      context.fillRect(0, 0, context.canvas.width, context.canvas.height)
    },
    // runCanvas ({ context }) {
    //   // begin custom shape
    //   context.beginPath()
    //   context.moveTo(170, 80)
    //   context.bezierCurveTo(130, 100, 130, 150, 230, 150)
    //   context.bezierCurveTo(250, 180, 320, 180, 340, 150)
    //   context.bezierCurveTo(420, 150, 420, 120, 390, 100)
    //   context.bezierCurveTo(430, 40, 370, 30, 340, 50)
    //   context.bezierCurveTo(320, 5, 250, 20, 250, 50)
    //   context.bezierCurveTo(200, 5, 150, 20, 170, 80)

    //   // complete custom shape
    //   context.closePath()
    //   context.lineWidth = 5
    //   context.fillStyle = '#8ED6FF'
    //   context.fill()
    //   context.strokeStyle = 'blue'
    //   context.stroke()
    // },
    sendCanvas () {
      let canvas = this.$refs['cancan']
      // let context = canvas.getContext('2d')
      // this.runCanvas({ context })
      var dataURL = canvas.toDataURL('image/jpeg', 0.7)
      // var data = dataURItoBlob(dataURL)
      this.$emit('send', { imageURL: dataURL })
      this.$emit('sending', true)
      this.$emit('show', 'mainscreen')
    }
  }
}
</script>

<style scoped>
.icon-margin{
  margin: 10px 10px 10px 0px;
}
.cancan{
  width: 100%;
}
.draw-div{
  background-color: rgb(230, 255, 233);
  width: 100%;
  height: 100%;
  /* height: 100%; */
  display: flex;
  justify-content: center;
  align-items: center;
  align-self: stretch;
  justify-self: stretch;
}
.anchor-top-left{
  position: absolute;
  top: 0px;
  left: 0px;
}
</style>
